<template>
  <quill-editor
    class="qs_editor mb-1"
    v-model="text"
    :ref="reference"
    :options="editorOption"
    @focus="onEditorFocus"
    @ready="onReady"
    >
  </quill-editor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

export default {
  name: 'editor',
  components: {
    quillEditor,
  },
  props: {
    model: {
      type: String,
      default() {
        return '';
      },
    },
    reference: {
      type: String,
      default: 'editor',
    },
    placeholder: {
      type: String,
      default: 'Text formatado',
    },
    editorOption: {
      type: Object,
      default: () => ({
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
          ],
        },
      }),
    },
  },
  data() {
    return {
      quill: null,
    };
  },
  methods: {
    onEditorFocus(quill) {
      this.$emit('focus', quill);
    },
    onReady(quill) {
      this.$emit('ready', quill);
    },
  },
  computed: {
    text: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
    editor() {
      return this.$refs[this.reference].quill;
    },
  },
};
</script>
